<template>
  <div class="notification-count" v-if="unreadCount > 0">{{unreadCount}}</div>
</template>

<script>
import { mapActions } from 'vuex'
import { db } from '../../../firebase'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'channel-all-unread-counter',
  props: ['externalId'],
  data: (vm) => {
    return {
      unread: [],
      unreadList: [],
      unreadCount: 0,
      currentChannel: vm.externalId,
      userId: localStore.getItem('userid')
    }
  },
  beforeCreate () {
    this.$store.state.channel.unreadCountState = 0
    this.$store.state.channel.channelUnreadCount = {}
  },
  created () {
    this.currentChannel = this.externalId
    this.$watch('currentChannel', (selectedChannelId) => {
      if (selectedChannelId) {
        this.$bindAsArray('unread', db.ref('channels/' + selectedChannelId + '/unread/' + this.userId))
      }
      this.$bindAsArray('unreadList', db.ref('Unread/' + this.userId))
    }, {
      immediate: true
    })
  },
  methods: {
    ...mapActions([
      'updateUnread'
    ])
  },
  watch: {
    unread (newUnread) {
      this.updateUnread({channelId: this.currentChannel, unread: newUnread.length})
    },
    unreadList (newUnreadList) {
      newUnreadList.forEach(data => {
        this.unreadCount += data.unreadCount
        this.updateUnread({channelId: data.channelId, unread: data.unreadCount})
      })
    }
  }
}
</script>
<style>
  .notification-count {
    font-size: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/channel/components/ChannelUnreadCounter.vue